import { render, staticRenderFns } from "./addAdverseEvent.vue?vue&type=template&id=42820fce&scoped=true"
import script from "./addAdverseEvent.vue?vue&type=script&lang=js"
export * from "./addAdverseEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42820fce",
  null
  
)

export default component.exports